module.exports = __webpack_public_path__ + "95330f5ce906dd2721d6bace1b514e3d.svg";